module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-700-bold-65e5fc42cf36a3e4043eb45d75d309b9.woff";